module.exports = "<p>\r\n  budget works!\r\n</p>\r\n"